import React, { useEffect } from 'react'
import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useUserStore } from '../../store/userStore'
import { checkUserApi } from '../../api/user'

const ProtectedRoute = () => {
    const { userInfo, logoutAction } = useUserStore(state => state)
    const location = useLocation()

    useEffect(() => {
        if (userInfo) {
            // 백엔드 유저 검사
            checkUserInfo(userInfo.user_id)
        } else {
            logoutAction()
        }
    }, [])

    const checkUserInfo = async (userId) => {
        try {
            await checkUserApi(userId)
        }
        catch (error) {
            logoutAction() // 로그아웃 처리
        }
    }


    return userInfo ? <Outlet /> : <Navigate to={'/login'} replace={true} state={{ from: location }} />

}

export default ProtectedRoute